import React from "react";

function About() {
  return (
    <section className="why_choose_us pt_150" data-aos="fade-up">
      <div className="container">
        <div className="row why_choose_us_row">
          {/* Left Content */}
          <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
            <div
              className="why_choose_left"
              data-aos="fade-right"
              data-aos-easing="linear"
              data-aos-duration="500"
            >
              <h2>Getting Started with Eco Mantra Capital</h2>
              <p>
                Launch your financial transformation journey in minutes with our
                streamlined onboarding process and intelligent automation.
              </p>
            </div>
          </div>

          {/* Right Content */}
          <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12">
            <div
              className="why_choose_right"
              data-aos="fade-left"
              data-aos-easing="linear"
              data-aos-duration="600"
            >
              <div className="row">
                {/* Block 1 */}
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 colmun">
                  <div
                    className="why_choose_block_one space_100"
                    data-aos="fade-up"
                    data-aos-easing="linear"
                    data-aos-duration="600"
                    data-aos-delay="100"
                  >
                    <div className="choose_icon">
                      <i class="fa-solid fa-user-pen"></i>
                    </div>
                    <h4>Create Account</h4>
                    <p>
                      Sign up for a Eco Mantra Capital account and complete our
                      secure verification process to get started.
                    </p>
                    <ul>
                      <li>Secure verification</li>
                      <li>Identity protection</li>
                      <li>Instant setup</li>
                    </ul>
                  </div>
                </div>

                {/* Block 2 */}
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 colmun">
                  <div
                    className="why_choose_block_one mt_70 mb_40"
                    data-aos="fade-up"
                    data-aos-easing="linear"
                    data-aos-duration="650"
                    data-aos-delay="200"
                  >
                    <div className="choose_icon">
                      <i class="fa-regular fa-calendar-days"></i>
                    </div>
                    <h4>Activate Algorithms</h4>
                    <p>
                      Launch our intelligent algorithms to begin arranging
                      optimal loans or managing your crypto investments.
                    </p>
                    <ul>
                      <li>AI-powered matching</li>
                      <li>Real-time analysis</li>
                      <li>Smart recommendations</li>
                    </ul>
                  </div>
                </div>

                {/* Block 3 */}
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 colmun">
                  <div
                    className="why_choose_block_one mt_-70 mb_40"
                    data-aos="fade-up"
                    data-aos-easing="linear"
                    data-aos-duration="700"
                    data-aos-delay="300"
                  >
                    <div className="choose_icon">
                      <i className="fas fa-leaf"></i> {/* Leaf icon */}
                    </div>
                    <h4>Set Preferences</h4>
                    <p>
                      Define your financial goals, risk tolerance and
                      preferences to customize our algorithms to your needs.
                    </p>
                    <ul>
                      <li>Custom goals</li>
                      <li>Risk assessment</li>
                      <li>Personal preferences</li>
                    </ul>
                  </div>
                </div>

                {/* Block 4 */}
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 colmun">
                  <div
                    className="why_choose_block_one"
                    data-aos="fade-up"
                    data-aos-easing="linear"
                    data-aos-duration="750"
                    data-aos-delay="400"
                  >
                    <div className="choose_icon">
                      <i className="fas fa-chart-line"></i> {/* Bar chart */}
                    </div>
                    <h4>Monitor & Adjust</h4>
                    <p>
                      Track performance through our intuitive dashboard and make
                      adjustments as your financial goals evolve.
                    </p>
                    <ul>
                      <li>Live dashboard</li>
                      <li>Performance tracking</li>
                      <li>Smart adjustments</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
